module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_3@2x.911c76a.jpg";